import React, { useCallback, useState } from "react";
import { FaTrashAlt } from "react-icons/fa";
import ModalContainer from "../modals/ModalContainer";
import Select from "../form/select/Select";
import { useSelector } from "react-redux";
import SelectCover from "../modals/policy/SelectCover";

const Cover = ({ genInfoRef, interestRef, setCover }) => {
  const { cover } = useSelector((state) => state.policy);
  const [data, setData] = useState([]);
  const [error, setError] = useState("");

  const setErrorMemo = useCallback((dataCheck) => {
    if (dataCheck.every((item) => item.value === "")) {
      setError("Atleast one cover is required");
      return;
    } else {
      setError("");
    }
  });

  const handleChange = (value) => {
    if (data.includes(value.value)) return;
    let newData;
    if (data.length === "") {
      newData = [value];
    } else {
      newData = [...data, value];
    }
    setData(newData);
    setCover(newData.map((item) => item.value));
    setErrorMemo(newData);
  };

  const DeleteCover = (e, i) => {
    const deleteCover = [...data];
    deleteCover.splice(i, 1);
    setData(deleteCover);
    setCover(deleteCover);
    setErrorMemo(deleteCover);
  };

  return (
    <div className='row'>
      <div className='col-md-12 mb-3'>
        <label htmlFor='cover_payable' className='form-label'>
          Cover Type<span className='text-danger'>*</span>
        </label>
        {data?.map((item, i) => (
          <div
            key={i}
            className='d-flex align-items-center justify-content-between shadow-sm p-2'
          >
            <span>{item?.label}</span>
            <span className='ms-3 cursor-p' onClick={(e) => DeleteCover(e, i)}>
              <FaTrashAlt size={12} className='text-danger' />
            </span>
          </div>
        ))}
        {error && <div className='text-danger'>{error}</div>}
      </div>
      <div className='col-md-12 mb-3'>
        <button
          className='btn btn-primary btn-sm'
          // onClick={(e) => {
          //   setData([...data, ""]);
          // }}
          data-bs-toggle='modal'
          data-bs-target='#cover-select'
        >
          <i className='mdi mdi-plus me-1'></i>
          <span>Add</span>
        </button>
      </div>
      <div className='mt-4 d-flex justify-content-end'>
        <button
          type='submit'
          className='btn btn-info text-white me-3'
          onClick={() => genInfoRef?.current?.click()}
        >
          <i className='mdi mdi-arrow-left me-1'></i>
        </button>
        <button
          type='submit'
          className='btn btn-primary text-white'
          onClick={() => {
            setErrorMemo(data);
            if (data.every((item) => item === "")) return;
            interestRef?.current?.click();
          }}
        >
          Next <i className='mdi mdi-arrow-right ms-1'></i>
        </button>
      </div>
      <SelectCover
        modal_id='cover-select'
        handleChange={handleChange}
        covers={data}
      />
    </div>
  );
};

export default Cover;
